import logger from '../utils/logger-rum';
import { Segment } from '../stores/types/segments';
import { getEmbedSafeHeaders } from './auth';
import blpAuth from './blp-auth';

export const SaveSegment = async (
	roomId: number,
	segment: Partial<Segment>,
): Promise<Segment | null> => await blpAuth.post({
	host: process.env.REACT_APP_SYNC_HOST,
	url: `/v1/room/${roomId}/segments/save/${segment.id || 0}`,
	token: blpAuth.accessToken,
	options: {headers: getEmbedSafeHeaders()},
	body: segment,
}).catch((err) => {
	const errorMessage = err?.error?.error ?? 'No error specified';
	logger.error('error saving segment: ', err);
	return errorMessage;
}).then((res) => res);

export const LoadSegments = async (
	roomId: number
) => blpAuth.get({
	host: process.env.REACT_APP_SYNC_HOST,
	url: `/v1/room/${roomId}/segments/load`,
	token: blpAuth.accessToken,
	options: {headers: getEmbedSafeHeaders()}
}).catch((err) => {
	logger.error('error loading segments: ', err);
	return null;
}).then((res) => res);

export const DeleteSegment = async (
	roomId: number,
	segmentId: number
) => blpAuth.delete({
	host: process.env.REACT_APP_SYNC_HOST,
	url: `/v1/room/${roomId}/segments/delete/${segmentId}`,
	token: blpAuth.accessToken,
	options: {headers: getEmbedSafeHeaders()}
}).catch((err) => {
	logger.error('error deleting segment: ', err);
	return null;
}).then((res) => res);
